import React, { useEffect, useState, useCallback } from "react";

import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setLoading, setModule } from "../../store/actions/commonAction";
import CommonDataService from "../../services/common";
import {
	AllowedUsergroup,
	GetIndexByValue,
	CDNWebsite,
	parseNumber,
} from "../../helpers/common";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import Divider from "@mui/material/Divider";
import SaveIcon from "@mui/icons-material/Save";
import dayjs from "dayjs";
import MessageDialog from "../MessageDialog";
import http from "../../http";
import UploadImages from "./uploadImages";

export default function AddGallery({ placeholder }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	let { id } = useParams();

	const company = useSelector((state) => state.commonReducer.user.company);
	const userGroup = useSelector((state) => state.commonReducer.user.usergroup);
	const token = useSelector((state) => state.commonReducer.user.token);
	const loading = useSelector((state) => state.commonReducer.loading);

	const [message, setMessage] = useState("");
	const [error, setError] = useState(false);

	const [thumbPath, setThumbPath] = useState([]);
	const [offices, setOffices] = useState([]);
	const [idOffice, setIdOffice] = useState(company);
	const [idOfficeAC, setIdOfficeAC] = useState(null);
	const [title, setTitle] = useState("");
	const [note, setNote] = useState("");
	const [publishTime, setPublishTime] = useState(dayjs());
	const [active, setActive] = useState("");
	const [uniqueName, setUniqueName] = useState("");
	const [image, setImage] = useState("");
	const [deleteItems, setDeleteItems] = useState("");

	const LoadSelect = useCallback(() => {
		dispatch(setLoading(true));
		dispatch(setModule("Gallery"));

		if (typeof id !== "undefined") {
			CommonDataService.getGalleryById(id).then((res) => {
				setIdOffice(res.data.Row.id_office);
				setTitle(res.data.Row.title);
				setNote(res.data.Row.note);
				setPublishTime(dayjs(res.data.Row.publish_time));
				setActive(res.data.Row.active);
				setUniqueName(res.data.Row.unique_name);
				setThumbPath(CDNWebsite() + res.data.Row.pic_thumb);

				dispatch(setLoading(false));
			});
		} else {
			dispatch(setLoading(false));
		}

		if (AllowedUsergroup(userGroup, "superuser-website")) {
			CommonDataService.getOffices().then((res) => {
				setOffices(res.data);
			});
		}
	}, [dispatch, id, userGroup]);

	useEffect(() => {
		setIdOfficeAC(GetIndexByValue(offices, idOffice));
	}, [offices, idOffice]);

	useEffect(() => {
		LoadSelect();
	}, [LoadSelect]);

	const handleSubmit = (event) => {
		event.preventDefault();

		const data = new FormData();

		if (typeof id === "undefined") {
			id = 0;
		}

		data.append("image", image);
		data.append("Id", id);
		data.append("IdOffice", parseNumber(idOffice));
		data.append("Title", title);
		data.append("Note", note);
		data.append(
			"PublishTime",
			dayjs(publishTime).format("YYYY-MM-DD HH:mm:ss")
		);
		data.append("Active", active);
		data.append("UniqueName", uniqueName);
		data.append("DeleteItems", deleteItems);

		dispatch(setLoading(true));

		http
			.post("/galleries/save", data, {
				headers: {
					"Content-Type": "multipart/form-data",
					Authorization: "Bearer " + token,
				},
			})
			.then((res) => {
				dispatch(setLoading(false));
				navigate("/gallery" + window.location.search);
			})
			.catch(function (error) {
				setMessage(error.response.data.message);
				setError(true);
				dispatch(setLoading(false));
			});
	};

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<MessageDialog show={error} message={message} dialogClose={setError} />

				<Paper
					sx={{
						p: 2,
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Box component="form" onSubmit={(e) => handleSubmit(e)}>
						<Typography variant="h5">Gallery Form</Typography>

						<Grid container spacing={3}>
							{AllowedUsergroup(userGroup, "superuser-website") && (
								<Grid item xs={12} sm={12}>
									<Autocomplete
										id="id_office"
										name="id_office"
										options={offices}
										getOptionLabel={(option) => option.name}
										isOptionEqualToValue={(option, value) =>
											option.value === value.value
										}
										fullWidth={true}
										onChange={(e, val) => {
											if (val !== null) {
												setIdOffice(val.id);
											} else {
												setIdOffice("");
											}
										}}
										value={idOfficeAC}
										sx={{ minWidth: 100 }}
										renderInput={(params) => (
											<TextField
												variant="standard"
												{...params}
												label="Office"
											/>
										)}
									/>
								</Grid>
							)}

							<Grid item xs={12} sm={12}>
								<div>
									<img alt="" height="100" src={thumbPath} />
								</div>
								<Button
									startIcon={<PhotoCamera />}
									variant="outlined"
									component="label"
								>
									Select Poster Image
									<input
										hidden
										onChange={(e) => {
											setImage(e.target.files[0]);
											const file = e.target.files[0];
											let reader = new FileReader();
											reader.readAsDataURL(file);
											reader.onload = () => {
												setThumbPath(reader.result);
											};
										}}
										accept="image/*"
										multiple
										type="file"
									/>
								</Button>
							</Grid>

							<Grid item xs={12} sm={6}>
								<TextField
									required
									label="Title"
									id="title"
									name="title"
									value={title}
									fullWidth
									variant="standard"
									onChange={(e) => setTitle(e.target.value)}
								/>
							</Grid>

							{typeof id !== "undefined" && (
								<Grid item xs={12} sm={6}>
									<TextField
										required
										label="Unique Name"
										value={uniqueName}
										fullWidth
										variant="standard"
										onChange={(e) => setUniqueName(e.target.value)}
									/>
								</Grid>
							)}
							<Grid item xs={12} sm={6}>
								<TextField
									label="Note"
									id="note"
									name="note"
									value={note}
									fullWidth
									multiline
									rows={4}
									onChange={(e) => setNote(e.target.value)}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DateTimePicker
										label="Publish Time"
										value={publishTime}
										onChange={(e) => setPublishTime(dayjs(e))}
										renderInput={(params) => <TextField {...params} />}
									/>
								</LocalizationProvider>
							</Grid>

							<Grid item xs={12} sm={6}>
								<FormControlLabel
									control={
										<Checkbox
											checked={active === "true" || active === true}
											onChange={(e) => setActive(e.target.checked)}
										/>
									}
									label="Active"
								/>
							</Grid>

							<Grid item xs={12} sm={12}>
								<Divider />
							</Grid>

							<UploadImages id={id} token={token} setDelete={setDeleteItems} />

							<Grid item xs={12} sm={12}>
								<Divider />
							</Grid>

							<Grid item xs={12} sm={12}>
								<Button
									variant="contained"
									component={Link}
									to={"/gallery" + window.location.search}
									startIcon={<ArrowBackIcon />}
									sx={{ mr: 1 }}
								>
									Cancel
								</Button>
								<Button
									type="submit"
									variant="contained"
									disabled={loading}
									startIcon={<SaveIcon />}
								>
									{loading && (
										<span>
											<span className="spinner-border spinner-border-sm"></span>
											&nbsp;
										</span>
									)}
									<span> {loading ? "Please Wait" : "Save"}</span>
								</Button>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</Grid>
		</Grid>
	);
}
